import { ImageContainerBlockProps } from './type';

interface Props {
  blockProps: ImageContainerBlockProps;
  scaleFactor?: number;
  isEditorMode?: boolean;
}

export const ImageContainerBlock: React.FC<Props> = ({
  blockProps,
  scaleFactor = 1,
  isEditorMode = false,
}) => {
  const {
    width,
    height,
    imageWidth,
    imageHeight,
    gap,
    direction,
    maxImages,
    images,
    isBorderVisible,
  } = blockProps;

  const list = images ?? [];
  const display = maxImages != null ? list.slice(0, maxImages) : list;
  const isPreview = display.length === 0;
  const previewCount = maxImages ?? 4;

  return isEditorMode || list?.length > 0 ? (
    <div
      style={{
        width: width * scaleFactor,
        height: height * scaleFactor,
        display: 'flex',
        flexDirection: direction,
        flexWrap: 'wrap',
        gap: gap * scaleFactor,
        overflow: 'hidden',
        boxSizing: 'border-box',
        border:
          isPreview || isBorderVisible ? `${scaleFactor}px solid #aaa` : 'none',
      }}
    >
      {isPreview
        ? Array.from({ length: previewCount }).map((_, i) => (
            <div
              key={i}
              style={{
                width: imageWidth * scaleFactor,
                height: imageHeight * scaleFactor,
                backgroundColor: '#e8e8e8',
                border: `${scaleFactor}px dashed #bbb`,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 8 * scaleFactor,
                color: '#aaa',
              }}
            >
              IMG
            </div>
          ))
        : display.map((src, i) => (
            <img
              key={i}
              src={src}
              style={{
                width: imageWidth * scaleFactor,
                height: imageHeight * scaleFactor,
                objectFit: 'contain',
                flexShrink: 0,
              }}
            />
          ))}
    </div>
  ) : null;
};
